module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choice"
  }, _vm._l((_vm.choices), function(label, choice) {
    return _c('a', {
      class: {
        'btn-secondary': _vm.value == choice
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.update(choice)
        }
      }
    }, [_vm._v("\n\t   " + _vm._s(label) + "\n\t")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82c2e32c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toggle.vue
// module id = 108
// module chunks = 0 1